import { useState } from 'react'
import { prizeList } from '@/config';
import { lottery, getChances } from '@/api';
import { isLogin } from '@/utils';
import openLogin from '@/utils/login';
import Prize from '@/components/Prize';
import ProdWin from '@/components/ProdWin';
import styles from './index.module.scss';
import lotteryBtnImg from '@/assets/images/lottery-btn.png'

const Machine = props => {
  const [ lottIndArr, setLottIndArr ] = useState(['init-3', 'init-5', 'init-4'])
  const [ playing, setPlaying ] = useState(false)
  const [ prizeIndex, setPrizeIndex ] = useState(-3)

  return (
    <div className={[styles.machine, props.className].join('\x20')}>
      <div className={styles.prizeWrap}>
        {
          Array.from({ length: 3 }).map((_, index) => {
            return <Prize index={index} target={lottIndArr[index]} className={styles.prize} key={ 'prize-' + index } />
          })
        }
      </div>
      <img
        data-event-param="老虎机-立即抽奖"
        data-event-name="老虎机-立即抽奖"
        otitle="老虎机-立即抽奖"
        otype="click"
        data-event-type="click"
        onClick={() => playGame(lottIndArr, setLottIndArr, playing, setPlaying, setPrizeIndex)} className={styles.lotteryBtn} src={lotteryBtnImg} alt="lottery" />
      {
        prizeIndex > -3 ? <ProdWin prizeIndex={prizeIndex} onSeeMyPrize={() => props.onSeeMyPrize()} onClick={() => setPrizeIndex(-3)} /> : ''
      }
    </div>
  );
}

function playGame(lottIndArr, setLottIndArr, playing, setPlaying, setPrizeIndex) {
  if(playing) {
    return
  }
  if(!isLogin()) {
    return openLogin()
  }
  let prefix = 'first'
  if(/^first/.test(`${lottIndArr[0]}`)) {
    prefix = 'second'
  }
  setPlaying(true)
  getChances().then(c => {
    if(c > 0) {
      lottery().then(({ prize }) => {
        prize = prize > -1 ? +prize : -1
        const target = prizeList[prize > -1 ? +prize : -1].imgIndex
        let indArr = [target, target, target]
        if(target < 0) {
          const r = Math.floor(Math.random() * 5)
          indArr = [r, Math.floor(Math.random() * 5), (r + 1) % 5]
        }
        setLottIndArr(indArr.map((item) => `${prefix}${item}`))
        setTimeout(() => {
          setPrizeIndex(prize)
          setPlaying(false)
        }, 4500)
      }).catch(() => setPlaying(false))
    } else {
      setPlaying(false)
      setPrizeIndex(-2)
    }
  }).catch(() => setPlaying(false))
}

export default Machine;
